import {
  TOGGLE_CART,
  UPDATE_ORDER_PENDING,
  UPDATE_ORDER_SUCCESS,
  ADD_TO_CART_PENDING,
} from './actions';

const initialState = {
  cart: null,
  cartShown: false,
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case UPDATE_ORDER_PENDING:
    case ADD_TO_CART_PENDING:
      return Object.assign({}, state, { isLoading: true });

    case TOGGLE_CART:
      return Object.assign({}, state, { cartShown: !state.cartShown });

    case UPDATE_ORDER_SUCCESS:
      const cartShown = action.payload.item_count !== 0;
      return Object.assign({}, state, { cart: action.payload, isLoading: false, cartShown });

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./assets/scripts/redux/reducer.js